'use client'

/**
 * MessageContent — renders a message body in the web chat widget.
 *
 * Outbound / operator-authored text is parsed as a restricted Markdown subset
 * with strict sanitization. Inbound (visitor) and system messages render as
 * plain text so `**hello**` typed by a visitor appears literally.
 *
 * The renderer itself is shared with the dashboard — see
 * `components/ui/markdown-message.tsx`. The widget uses the bare variant: its
 * global CSS (`app/(widget)/layout.tsx`) styles the Markdown output through
 * direct-child selectors that a wrapper element would break.
 */

import { MarkdownMessage } from '@/components/ui/markdown-message'

interface MessageContentProps {
  text: string
  direction: 'inbound' | 'outbound' | 'system'
}

export function MessageContent({ text, direction }: MessageContentProps) {
  if (direction !== 'outbound') {
    return <>{text}</>
  }

  return <MarkdownMessage text={text} hideLinkProtocol />
}
